import styled from 'styled-components';

export const AppContainer = styled.div`
  background-color: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.color};
  width: 100%;
`;

export const PageWrapper = styled.div `
     @media (min-width: 1366px) {
      width: 1300px;
      margin: auto;
  }
      @media(max-width: 1365.9px) {
        max-width: 100%;
        margin: auto;
        padding-left: 32px;
        padding-right: 32px;
      }
`

export const ToggleButton = styled.button`
  background-color: ${({ theme }) => theme.color};
  color: ${({ theme }) => theme.background};
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 20px;
  border-radius: 5px;
  transition: all 0.3s ease;
  
  &:hover {
    opacity: 0.8;
  }
`;
